import http from "@/http";

const ProjetosService = {
  async buscarRelatorioProjetosGeral(dadosFiltro, onProgress = null) {
    try {
      const config = onProgress
        ? {
            onUploadProgress: progressEvent => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              onProgress(percentCompleted);
            }
          }
        : {};
      const response = await http.post(
        "/api/astec/relatorios/projetos/geral",
        dadosFiltro,
        {
          ...config,
          responseType: "blob"
        }
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar projetos:", error);
      throw error;
    }
  },

  async buscarRelatorioProjetosGeralCsv(dadosFiltro, onProgress = null) {
    try {
      const config = onProgress
        ? {
            onUploadProgress: progressEvent => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              onProgress(percentCompleted);
            }
          }
        : {};
      const response = await http.post(
        "/api/astec/relatorios/projetos/geral/csv",
        dadosFiltro,
        {
          ...config,
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Accept: "text/csv"
          }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.message || "Erro ao gerar CSV");
        } catch (parseError) {
          console.warn("Não foi possível parsear erro:", parseError);
          throw new Error("Erro no servidor ao gerar relatório");
        }
      }

      throw error;
    }
  },

  async getLkpMesReferencia(cdPessoa) {
    try {
      const response = await http.get(
        `/api/astec/projetos/mesReferencia/${cdPessoa}`
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar meses de referência:", error);
      throw error;
    }
  },

  async getLkpProjetosPorMesReferencia(dados) {
    try {
      const url = `/api/astec/projetos/projetoMesReferencia/${dados.cdPessoa}/${dados.dtReferencia}`;

      const response = await http.get(url);

      if (response.data.status) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || "Erro ao buscar projetos");
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        let mensagemErro = "Erro de validação: ";
        Object.keys(errors).forEach(key => {
          mensagemErro += `${errors[key].join(", ")}. `;
        });
        throw new Error(mensagemErro);
      }
      if (error.response) {
        throw new Error(
          `Erro ${error.response.status}: ${error.response.data?.message ||
            "Erro desconhecido"}`
        );
      }

      if (error.request) {
        throw new Error("Não foi possível conectar ao servidor");
      }

      throw error;
    }
  },

  async buscarItensProjetos(novoFiltro, page = 1, perPage = 10) {
    try {
      const response = await http.post("/api/astec/getProjetos", {
        ...novoFiltro,
        page,
        per_page: perPage
      });

      return response.data;
    } catch (error) {
      console.error("Erro no service:", error);
      return {
        data: [],
        total: 0,
        current_page: Number(page)
      };
    }
  }
};

export default ProjetosService;
